import { getHomeDiscount, getHomeGoodprice, getHomeHighScore, getHomeHotRecommend, getHomeLongfor, getHomePlus } from '@/services'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const fetechHomeDataAction = createAsyncThunk('homedata', (payload, { dispatch }) => {
  // 高性价比
  getHomeGoodprice().then((res) => {
    dispatch(changeGoodPriceAction(res))
  })

  // 高分房源
  getHomeHighScore().then((res) => {
    dispatch(changeHighScoreAction(res))
  })

  // 折扣优惠
  getHomeDiscount().then((res) => {
    dispatch(changeDiscountAction(res))
  })

  // 热门推荐
  getHomeHotRecommend().then((res) => {
    dispatch(changeHotRecommendAction(res))
  })

  // 向往城市
  getHomeLongfor().then(res => {
    dispatch(changeLongforAction(res))
  })

  // plus房源
  getHomePlus().then((res) => {
    dispatch(changePlusAction(res))
  })
})

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    goodPrice: {},
    highScore: {},
    discount: {},
    hotRecommend: {},
    longfor: {},
    plus: {}
  },
  reducers: {
    changeGoodPriceAction(state, { payload }) {
      state.goodPrice = payload
    },
    changeHighScoreAction(state, { payload }) {
      state.highScore = payload
    },
    changeDiscountAction(state, { payload }) {
      state.discount = payload
    },
    changeHotRecommendAction(state, { payload }) {
      state.hotRecommend = payload
    },
    changeLongforAction(state, { payload }) {
      state.longfor = payload
    },
    changePlusAction(state, { payload }) {
      state.plus = payload
    }
  },
  extraReducers: {
    [fetechHomeDataAction.fulfilled](state, { payload }) {
      state.goodPrice = payload
    }
  }
})

export const {
  changeGoodPriceAction,
  changeHighScoreAction,
  changeDiscountAction,
  changeHotRecommendAction,
  changeLongforAction,
  changePlusAction
} = homeSlice.actions
export default homeSlice.reducer
